import { IFetcherOptions } from './fetcher.ts';
import { SerializableResponseData } from '@moment/net/common/cache.ts';
import { computeChecksum } from '@utils/crypt-util.ts';


export function generateCacheKey(
  url: string | URL | Request,
  options?: IFetcherOptions
): string {
  const urlString = typeof url === 'string' ? url : url.toString();
  let keyData = urlString;
  if (options) {
    const relevantOptions: Record<string, any> = {
      method: options.method || 'GET',
      headers: {},
      cacheKeyData: options.cacheKeyData,
    };

    if (options.headers) {
      const headers = options.headers as Record<string, string>;
      if (headers['Accept-Language']) {
        relevantOptions.headers['Accept-Language'] = headers['Accept-Language'];
      }
      if (headers['Content-Type']) { // Relevant for POST/PUT etc.
        relevantOptions.headers['Content-Type'] = headers['Content-Type'];
      }
    }
    if (options.method && options.method.toUpperCase() !== 'GET' && options.body) {
      relevantOptions.body = options.body.toString(); // Or a more robust serialization
    }
    keyData += JSON.stringify(relevantOptions);
  }
  return computeChecksum([keyData])
}

export async function serializeResponse(response: Response): Promise<SerializableResponseData> {
  const headers: Record<string, string> = {};
  response.headers.forEach((value, key) => {
    headers[key] = value;
  });
  // IMPORTANT: response.text() consumes the body stream.
  // If you need to use the response again after this, you'll need to clone it first.
  // const clonedResponse = response.clone();
  // const body = await clonedResponse.text();
  const body = await response.text();


  return {
    body,
    headers,
    status: response.status,
    statusText: response.statusText,
    url: response.url, // The final URL after any redirects
  };
}

export function deserializeResponse(data: SerializableResponseData): Response {
  return new Response(data.body, {
    status: data.status,
    statusText: data.statusText,
    headers: new Headers(data.headers),
    // Note: The URL of the constructed Response object might not perfectly
    // reflect the original response.url if it was a result of redirects,
    // but data.url stores that original final URL.
  });
}
